import React, { Component } from 'react';
import { Overlay, Tooltip } from 'react-bootstrap';
import './UserGuider.scss';

export default class UserGuider extends Component {
    state={isShowToolTip:false}
    componentDidMount(){
        if (sessionStorage.getItem(`ToolTipFor${this.props.name}`) !== 'Y')
        setTimeout(() => {
            this.setState({ isShowToolTip: true }, () => {
                sessionStorage.setItem(`ToolTipFor${this.props.name}`, 'Y');

                setTimeout(() => {
                    this.setState({ isShowToolTip: false });
                }, 7000);
            });
        }, 500);
    }
  render() {
     const {name, target, placement, content} = this.props;
    return ( 
        <Overlay transition target={target}
        show={this.state.isShowToolTip} placement={placement} >
            {(props) => (
                <Tooltip {...props} onClick={() => {
                    this.setState({ isShowToolTip: false });
                    sessionStorage.setItem(`ToolTipFor${name}`, 'Y');
                }}>
                    <i className="fas fa-times justify-content-end d-flex cursor-pointer" />
                        {content}
                </Tooltip>
            )}

        </Overlay>
    );
  }
}
